import React, { memo } from 'react';

import Button from '@components/common/Button';

import styles from './ConfigFileView.module.scss';

const ConfigFileView = ({
	text,
	onClose,
}: {
	text?: string;
	onClose: () => void;
}) => {
	return (
		<>
			<div className={styles.textContainer}>
				{text}
			</div>
			<div className={styles.closeButtonContainer}>
				<Button
					large
					onClick={onClose}
					text='Close'
				/>
			</div>
		</>
	);
};

export default memo(ConfigFileView);
